import SyncProvider from "../enums/sync-provider.ts";
import ProjectSynchronizationDto from "../interfaces/dtos/project-synchronization-dto.ts";

class ProjectSynchronisation {
    id: string;
    
    projectId: string;
    
    provider: SyncProvider;

    providerHubId?: string;

    providerProjectId: string;
    
    syncBy: string;

    webhookId?: string;

    token?: string;

    executeWorkflow: boolean;

    workflowName: string;

    lastSyncDate?: Date;
    
    isUpToDate: boolean;

    constructor(dto: ProjectSynchronizationDto) {
        this.id = dto.id;
        this.projectId = dto.projectId;
        this.provider = dto.provider;
        this.providerHubId = dto.providerHubId;
        this.providerProjectId = dto.providerProjectId;
        this.syncBy = dto.syncBy;
        this.webhookId = dto.webhookId;
        this.token = dto.token;
        this.executeWorkflow = dto.executeWorkflow;
        this.workflowName = dto.workflowName;
        this.lastSyncDate = dto.lastSyncDate;
        this.isUpToDate = dto.isUpToDate;
    }
}

export default ProjectSynchronisation;